import React, { Dispatch, SetStateAction } from 'react';
import { ModalType } from '../../../types/Modal';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../../ui/dialog';

export type ModalChildrenProps<Data> = (
    data: Data,
    setData: Dispatch<SetStateAction<Data>>
) => React.ReactNode | React.ReactNode[];

export interface DialogFormProps<Data> {
    title?: React.ReactNode;
    children: ModalChildrenProps<Data> | React.ReactNode;
    footer?: ModalChildrenProps<Data> | React.ReactNode;
    open?: boolean;
    onClose?: (open: boolean) => void;
    className?: string;
    noClose?: boolean;
    state?: Data;
    titleClassName?: string;
}

export type ModalPropsWrapper = { type: ModalType.DYNAMIC; data: DialogFormProps<any> };

export default function ModalComponent<Data>({
    title,
    children,
    footer,
    open = true,
    onClose,
    className = '',
    state,
    titleClassName = 'text-2xl text-center font-bold text-purple-800',
    noClose = false,
}: DialogFormProps<Data>) {
    const [data, setData] = React.useState(state as Data);

    return (
        <Dialog open={open} onOpenChange={!noClose ? onClose : undefined}>
            <DialogContent className={className?.concat(' block')}>
                {title && (
                    <DialogHeader className="h-[40px]">
                        <DialogTitle className={titleClassName}>{title}</DialogTitle>
                    </DialogHeader>
                )}

                <div className={(footer ? 'h-[calc(100%_-_80px)]' : 'h-[calc(100%_-_40px)]').concat(' ', '')}>
                    {typeof children === 'function' ? children?.(data, setData) : children}
                </div>
                {footer && (
                    <DialogFooter className="h-[40px]">
                        {typeof footer === 'function' ? footer?.(data, setData) : footer}
                    </DialogFooter>
                )}
            </DialogContent>
        </Dialog>
    );
}
